import React from 'react'
import { createUseStyles } from 'react-jss'
import { ChevronRight } from '../../../assets/icons'
import { colors } from '../../../theme/palette'
import { sortProperty, sortProperties } from '../../../utils/sortHelper'
import {
    SortCaseProperty,
    SortCasesProperties,
    SortCasesDirection,
} from '../../../utils/sortCasesHelper'

interface Props {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    sort: sortProperty
    name: sortProperties
}

interface SortCasesProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    sort: SortCaseProperty
    name: SortCasesProperties
}

const useStyles = createUseStyles(() => ({
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.75em 0',
        margin: '0 0.3em 0.3em 0',
        borderRadius: '6px',
        boxSizing: 'border-box',
        textDecoration: 'none',
        fontWeight: 400,
        textAlign: 'center',
        transition: 'all 0.2s',
        boxShadow: 0,
        '&:hover': {
            cursor: 'pointer',
            color: colors.black,
            fontWeight: '700',
        },
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        fontStyle: 'normal',
        fontSize: '16px',
        lineHeight: '120%',
        color: '#000000',
        border: 0,
        background: 'none',
        '&.active': {
            textDecoration: 'underline',
            fontWeight: '700',
        },
    },
    icon: {
        display: 'flex',
        transform: 'rotate(-90deg)',
        position: 'relative',
        marginLeft: '10px',
        top: '1px',
        '.active &.ascending': {
            transform: 'rotate(90deg)',
        },
    },
}))

const SortButton: React.FC<Props> = ({ onClick, sort, name, children }) => {
    const classes = useStyles()

    return (
        <button
            type="button"
            onClick={onClick}
            className={`${classes.button} ${
                sort && sort.property === name ? 'active' : 'passive'
            }`}
        >
            <span>{children}</span>

            <div
                className={`${classes.icon} ${
                    sort &&
                    sort.property === name &&
                    sort.direction === 'descending '
                        ? 'descending'
                        : 'ascending'
                }`}
            >
                <ChevronRight width="6px" color={colors.gray800} />
            </div>
        </button>
    )
}

const SortCasesButton: React.FC<SortCasesProps> = ({
    onClick,
    sort,
    name,
    children,
}) => {
    const classes = useStyles()

    return (
        <button
            type="button"
            onClick={onClick}
            className={`${classes.button} ${
                sort && sort.property === name ? 'active' : 'passive'
            }`}
        >
            <span>{children}</span>

            <div
                className={`${classes.icon} ${
                    sort && sort.property === name && sort.direction === 'Desc'
                        ? 'descending'
                        : 'ascending'
                }`}
            >
                <ChevronRight width="6px" color={colors.gray800} />
            </div>
        </button>
    )
}

export { SortButton, SortCasesButton }
